<div class="quick-quote__links">
    <div class="quick-quote__breadcrumbs">
        <a href="http://www.massmutual.com/insurance/life-insurance">Insurance</a> &nbsp;&gt;&nbsp;
        <a href="http://www.massmutual.com/direct">MassMutual&reg; Direct</a> &nbsp;&gt;&nbsp;
        <span>Get a Quote</span>
    </div>
</div>
<div class="quick-quote-container">
    <div class="quick-quote-form__header">
        <h2 class="quick-quote-form__header-text">Get a quote</h2>
    </div>
    <div class="quick-quote-form__paragraph">
        <div class="quick-quote-form__text">
            I am a
        </div>
        <div class="quick-quote-form__field-gender">
            <select-basic #genderInput
                class="quick-quote-form__select"
                propertyName="customer.mmdQuote.gender"
                (valueChanged)="handleChangeAndAttemptQuoteFetch()">
            </select-basic>
        </div>
        <div class="quick-quote-form__text">
                living in
        </div>
        <div class="quick-quote-form__group">
            <div class="quick-quote-form__field-state">
                <select-basic #stateInput
                    propertyName="customer.mmdQuote.contractState"
                    (valueChanged)="handleChangeAndAttemptQuoteFetch()">
                </select-basic>
            </div>
            <div class="quick-quote-form__text">
                <span class="quick-quote-form__punctuation">*.</span>
            </div>
        </div>
        <div class="quick-quote-form__text">
            I was born on
        </div>
        <div class="quick-quote-form__group">
            <div class="quick-quote-form__field-dob">
                <basic-text-input #dateOfBirthInput
                    class="quick-quote-form__select"
                    propertyName="customer.mmdQuote.dateOfBirth"
                    parserType="Date"
                    formatterType="date_mmddyyyy"
                    (valueChanged)="handleChangeAndAttemptQuoteFetch()">
                </basic-text-input>
            </div>
            <div class="quick-quote-form__text">
                <div class="quick-quote-form__punctuation">
                    .
                </div>
            </div>
        </div>
        <div class="quick-quote-form__text">
                I'm in
        </div>
        <div class="quick-quote-form__group">
            <div class="quick-quote-form__field-health">
                <select-basic #healthNumberInput
                    propertyName="customer.mmdQuote.healthClassNumber"
                    (valueChanged)="handleChangeAndAttemptQuoteFetch()">
                </select-basic>
            </div>
            <div class="quick-quote-form__text">
                    <tooltip [helpText]="healthClassText"></tooltip> and I
            </div>
        </div>
        <div class="quick-quote-form__field-smoker">
            <select-basic #smokerInput
                propertyName="customer.mmdQuote.smoker"
                (valueChanged)="handleChangeAndAttemptQuoteFetch()">
            </select-basic>
        </div>
        <div class="quick-quote-form__text">
            smoke. I want to protect
        </div>
        <div class="quick-quote-form__text">
            &nbsp;my family with a
        </div>
        <div class="quick-quote-form__field-faceamount">
            <basic-text-input #faceAmountInput
                propertyName="customer.mmdQuote.faceAmount"
                parserType="Currency"
                formatterType="currency"
                (valueChanged)="handleChangeAndAttemptQuoteFetch('faceAmountInput')">
            </basic-text-input>
        </div>
        <div class="quick-quote-form__text">
            policy lasting
        </div>
        <div class="quick-quote-form__field-term">
            <select-basic #termInput
                propertyName="customer.mmdQuote.term"
                (valueChanged)="handleChangeAndAttemptQuoteFetch()">
            </select-basic>
        </div>
        <div class="quick-quote-form__text">
            years.
        </div>
    </div>

    <div class="quick-quote-footer">
        <div *ngIf="applyEnabled" class="quick-quote-footer__estimate">
            <div class="quick-quote-footer__estimate-subheading">
                Your Estimate
            </div>

            <radio-group
                [modifierClasses]="'radio-group--quick-quote quick-quote-form__radio-group'"
                propertyName="customer.mmdQuote.paymentFrequency"
                displayText="Payment Frequency"
                showTitle="Payment Frequency"
                [(ngModel)]="paymentFrequency"
                (valueChanged)="handleChangeAndAttemptQuoteFetch()"
                #paymentFrequencyInput>
            </radio-group>

            <div class="quick-quote-footer__estimate-body">
                <div class="quick-quote-footer__estimate-item">

                    <span class="quick-quote-footer__premium">
                        <sup class="quick-quote-footer__currency">$</sup>
                        {{estimatedMonthlyPremium}}
                    </span>

                    <sup class="quick-quote-footer__unit">/mo</sup>

                </div>
                <div class="quick-quote-footer__estimate-item">

                    <span class="quick-quote-footer__premium">
                        <sup class="quick-quote-footer__currency">$</sup>
                        {{estimatedAnnualPremium}}
                    </span>

                    <sup class="quick-quote-footer__unit">/yr</sup>

                </div>
            </div>
            <div *ngIf="showWOP" class="quick-quote-footer__option">
                <basic-checkbox #waiverOfPremiumInput
                    propertyName="customer.mmdQuote.waiverOfPremium"
                    (valueChanged)="handleChangeAndAttemptQuoteFetch()"
                    [inputClass]="'checkbox__label--light'">
                </basic-checkbox>
                <div class="quick-quote-footer__estimate-wop">
                    Include Waiver of Premium for ${{estimatedWOP}}/{{frequencyUnit}}?
                    <tooltip [helpText]="'Waiver Of Premium is an optional benefit
                    available at additional cost that ensures your
                    coverage will continue if you become totally
                    disabled. If you select this option now you can
                    always remove it later.'">
                    </tooltip>
                </div>
            </div>
            <div *ngIf="showECP" class="quick-quote-footer__option">
                <basic-checkbox #extendedConvertibilityInput
                                propertyName="customer.mmdQuote.hasEcp"
                                (valueChanged)="handleChangeAndAttemptQuoteFetch()"
                                [inputClass]="'checkbox__label--light'">
                </basic-checkbox>
                <div class="quick-quote-footer__estimate-ecp">
                    Purchase Extended Period of Convertibility?
                    <tooltip>
                        <div tip>
                            <p class="tooltip__text">Your policy can have an Extended Conversion Period (ECP), which allows more time to convert. You can convert some or all of your Term coverage into Whole Life coverage.</p>
                        </div>
                    </tooltip>
                </div>
            </div>
        </div>
            <div class="quick-quote-footer__button-container">
                <button class="button button--yellow button--primary"
                        [ngClass]="{'button--disabled': !applyEnabled}"
                        [disabled]="applyEnabled ? null : 'true'"
                        (click)="applyNow()">
                    Apply Now
                </button>
            </div>
            <div class="quick-quote-footer__disclaimer">
                * Our convertible term product is only available in these states currently.
            </div>
    </div>
</div>
